export const SET_CLIENTS = 'SET_CLIENTS';
export const setClientsAction = (clients) => ({
  type: SET_CLIENTS,
  payload: clients,
});
